/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ChevronRegularRightLeadReport from './chevron-regular-right-lead-report-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ChevronRegularRightLeadReport {...validProps} />;
}

SvgComponent.iconName = 'chevronRegularRightLeadReport';

export const ChevronRegularRightLeadReportIcon = svgIconWrapper(SvgComponent);
